import { render, staticRenderFns } from "./ClientBranchListItem.vue?vue&type=template&id=efec883a&"
import script from "./ClientBranchListItem.vue?vue&type=script&lang=js&"
export * from "./ClientBranchListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports